import request from '@/utils/seftRequest';

// 查询未读公告
export function qryUnreadBltCounts(params) {
  return request('/ding/bulletin/qryUnreadBltCounts', { params });
}

// 查询登陆员工公告
export function qryReceivedBltList(params) {
  return request('/ding/bulletin/qryReceivedBltList', { params });
}

// 查询代理商员工充值列表
export function qryEnumberList4Staff(staffId) {
  return request(`/ding/etopup/qryEnumberList4Staff/${staffId}`);
}

// 查询代理商ENumber余额
export function agentEvoucherQry(params) {
  return request('/ding/etopup/agentEvoucherQry', { params });
}

// 查询当月的佣金额
export function commItemQuery(params) {
  return request('/ding/commission/commItemQuery', {
    method: 'POST',
    body: params,
  });
}

// 查询订单接口
export function qryOrderInfo4DRMBsnl(params) {
  return request('/ding/custService/qryOrderInfo4DRMBsnl', {
    method: 'POST',
    body: params,
  });
}

// 查询OSS侧在开通和错误的订单数量
export function queryOssOrderCountBsnl(params) {
  return request('/ding/custService/queryOssOrderCountBsnl', { params });
}

// 查询代理商绑定订户统计信息
export function qryOrgBindSubsSummary(params) {
  return request('/ding/channel/qryOrgBindSubsSummary', { params });
}

// 查询待处理TT数量
export function qryTaskCntBsnl(params) {
  return request('/ding/troubleTicket/qryTaskCntBsnl', { params });
}
